import { render, staticRenderFns } from "./ServiceDescriptionSetupList.vue?vue&type=template&id=19627143&scoped=true&"
import script from "./ServiceDescriptionSetupList.vue?vue&type=script&lang=js&"
export * from "./ServiceDescriptionSetupList.vue?vue&type=script&lang=js&"
import style0 from "./ServiceDescriptionSetupList.vue?vue&type=style&index=0&id=19627143&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19627143",
  null
  
)

export default component.exports